var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-ptz_wrap"},[_c('div',{staticClass:"control_panel"},[_c('div',{attrs:{"id":"dhplayer-pan-tilt"}})])])
}]

export { render, staticRenderFns }